import { UploadFileController } from './upload-file.controller'

const component = {
  templateUrl: '/core/components/upload-file/upload-file.html?$$REVISION$$',
  bindings: {
    file: '<',
    abort: '&'
  },
  controllerAs: '$ctrl',
  controller: UploadFileController
}

export const uploadFile = component
